export default __webpack_public_path__ + "static/media/default-product.e5676590.webp";